"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyPetDetails = exports.default = exports.PetDetailsPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PetDetailsPropType = exports.PetDetailsPropType = {
  petName: _propTypes.default.string,
  petDOB: _propTypes.default.string,
  gender: _propTypes.default.oneOf(['Male', 'Female', '']),
  breed: _propTypes.default.string,
  desexed: _propTypes.default.oneOf([1, 0, '', 2]),
  species: _propTypes.default.oneOf(['Dog', 'Cat', ''])
};
const emptyPetDetails = exports.emptyPetDetails = {
  petName: '',
  petDOB: '',
  gender: '',
  breed: '',
  desexed: '',
  species: ''
};
var _default = exports.default = {
  PetDetailsPropType,
  emptyPetDetails
};